import React, { useState, useEffect } from "react";
import img1 from "../../assets/faces.webp";
import img3 from "../../assets/duo-acrylic.webp";

function ImageSlider() {
  const [showFirstImage, setShowFirstImage] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowFirstImage((prev) => !prev);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-[300px] md:h-[631px] shadow-iris">
      <div
        className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
          showFirstImage ? "opacity-100" : "opacity-0"
        }`}
        style={{ backgroundImage: `url(${img1})` }}
      />
      <div
        className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
          !showFirstImage ? "opacity-100" : "opacity-0"
        }`}
        style={{ backgroundImage: `url(${img3})` }}
      />
    </div>
  );
}

export default ImageSlider;
